import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import { bindSplideLazyLoad } from './splide-lazy-load';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-video.css';

document.addEventListener('DOMContentLoaded', () => {

        const singleProductPage = document.querySelector('.single-product')

        if (singleProductPage !== null) {

            document.querySelectorAll('select[name="quantity"]').forEach(quantityInput => {

                quantityInput.addEventListener('change', () => {
                    const submitButton = document.querySelector('.js-product-multiple-submit')
                    const id = quantityInput.closest('.js-input-container').dataset.id
                    const value = quantityInput.value
                    const hiddenInput = document.querySelector('input[name="quantity[' + id + ']"]')

                    submitButton.classList.add('disabled')

                    if (hiddenInput) {
                        hiddenInput.value = value;
                    }

                    document.querySelectorAll('.js-product-multiple-input-hidden').forEach(input => {

                        if (input.value > 0) {
                            submitButton.classList.remove('disabled')
                        }
                    })

                });

            });

            /** Setup sliders */
            const mainSliderClass = '.splide-main.splide'

            const slider = new Splide(mainSliderClass, {
                fixedWidth: '100%',
                fixedHeight: '68.7rem',
                rewind: true,
                pagination: false,
                arrows: true,
                breakpoints: {
                    1024: {
                        fixedHeight: '35.3rem',
                    },
                },
            })

            const thumbnails = new Splide('.splide-thumbnails', {
                fixedWidth: 'calc((100% / 3) - 1rem)',
                fixedHeight: '20rem',
                gap: '2rem',
                rewind: true,
                pagination: false,
                arrows: true,
                isNavigation: true,
                breakpoints: {
                    1024: {
                        fixedWidth: '10rem',
                        fixedHeight: '8rem',
                        gap: '1rem',
                    },
                },

            })

            slider.sync(thumbnails)
            slider.mount({Video})
            thumbnails.mount();

            bindSplideLazyLoad(slider, 1, 0)
            bindSplideLazyLoad(thumbnails, 3, 0)

            /** Simple product minus button logic */
            const minusButtons = document.querySelectorAll(".js-input-container .minus");

            if (minusButtons.length) {
                minusButtons.forEach(minusButton => {
                    minusButton.addEventListener('click', function () {
                        const id = this.getAttribute("data-id")
                        changeQuantityInput(id, -1)
                    });
                })
            }

            /** Simple product plus button logic */


            const plusButtons = document.querySelectorAll(".js-input-container .plus");

            if (plusButtons.length) {
                plusButtons.forEach(plusButton => {
                    plusButton.addEventListener('click', function () {
                        const id = this.getAttribute("data-id")
                        changeQuantityInput(id, +1)
                    });
                })
            }

            /** Simple product change quantity */

            const changeQuantityInput = (id, direction) => {

                const input = document.querySelector('.js-input-container[data-id="' + id + '"] input')
                let newValue = parseFloat(input.value + '') + parseFloat(direction)

                if (newValue >= 0) {
                    input.value = newValue
                }
            }

            /** Color collapse button */

            const productCollapseButton = document.querySelector('.js-product-collapse-button')

            if (typeof productCollapseButton !== 'undefined') {
                productCollapseButton?.addEventListener('click', function () {
                    document.querySelector('.c-product-collection__colours').classList.add('is-collapsed')
                })
            }

            /** Color slider */
            document.querySelectorAll('.c-product-collection__colours__item').forEach(function (color) {
                color.addEventListener('click', function (e) {
                    e.preventDefault();

                    const selectedImageUrl = this.dataset.imageurl
                    const selectedColourCode = this.dataset.cc
                    const selectedUrl = this.dataset.url
                    const selectedSrcSet = this.dataset.srcset
                    const productTitle = this.dataset.producttitle

                    const parentImage = document.querySelector('.c-product-collection__current__image img')
                    const currentColors = document.querySelectorAll('.c-product-collection__colours__item.is-current')
                    const collectionButton = document.querySelector('.js-collection-button')

                    if (selectedUrl) {
                        collectionButton.style.display = 'block'
                        collectionButton.href = selectedUrl
                    }

                    if (!selectedUrl) {
                        collectionButton.style.display = 'none'
                    }

                    document.querySelector('.c-product-collection__current h4 strong').innerHTML = selectedColourCode

                    let elementStrong = document.querySelector('.c-product-collection__current h4 strong');
                    if (elementStrong) {
                        elementStrong.innerHTML = selectedColourCode;
                    }

                    let elementProductTitle = document.querySelector('.c-product-collection__current h4 .product-title');
                    if (elementProductTitle) {
                        elementProductTitle.innerHTML = productTitle;
                    }

                    if (parentImage && selectedImageUrl) {
                        const imageWrapper = parentImage.closest('.c-product-collection__current__image')
                        const spinner = imageWrapper?.querySelector('.c-product-collection__current__spinner')

                        const onImageReady = () => {
                            imageWrapper?.classList.remove('is-loading')
                            if (spinner) {
                                spinner.hidden = true
                            }
                        }

                        imageWrapper?.classList.add('is-loading')
                        if (spinner) {
                            spinner.hidden = false
                        }

                        parentImage.addEventListener('load', onImageReady, { once: true })
                        parentImage.addEventListener('error', onImageReady, { once: true })
                        parentImage.src = selectedImageUrl

                        if (selectedSrcSet) {
                            parentImage.srcset = selectedSrcSet
                        }

                        if (parentImage.complete) {
                            onImageReady()
                        }
                    }

                    currentColors?.forEach(function (currentColor) {
                        currentColor.classList.remove('is-current')
                    })

                    this.classList.add('is-current')

                })
            })


            // Track if modal content has been loaded
            let modalContentLoaded = false;

            // Function to initialize modal event listeners after AJAX load
            function initializeModalEventListeners() {
                const selectAll = document.querySelector('.js-modal-select-all')
                if (!selectAll) return;

                // Add close button event listener (loaded via AJAX)
                const closeButton = document.querySelector('.c-download-modal__close')
                if (closeButton) {
                    closeButton.addEventListener('click', function (e) {
                        e.stopPropagation()
                        const modalScreen = document.querySelector('.js-image-modal')
                        const documentBody = document.body
                        modalScreen.classList.remove('open')
                        documentBody.classList.remove('no-scroll')
                    })
                }

                selectAll.addEventListener('click', function () {
                    document.querySelectorAll('.js-modal-item-select').forEach(function (checkbox) {
                        selectAll.checked === true ? checkbox.checked = true : checkbox.checked = false
                    })
                    document.querySelector('.js-download-selection').disabled = !selectAll.checked
                })

                const fileSelects = document.querySelectorAll('.js-modal-item-select')
                const totalFiles = fileSelects.length
                let selectedFilesCount = 0

                fileSelects.forEach(function (checkbox) {
                    if (checkbox.checked === true) {
                        selectedFilesCount++
                    }

                    checkbox.addEventListener('change', function () {
                        checkbox.checked === true ? selectedFilesCount++ : selectedFilesCount--
                        selectedFilesCount === totalFiles ? selectAll.checked = true : selectAll.checked = false
                        document.querySelector('.js-download-selection').disabled = selectedFilesCount === 0
                    })
                })

                initializeModalDownloadButtons();
            }

            // Function to load modal content via AJAX
            function loadModalContent(modalScreen, callback) {
                const productId = modalScreen.dataset.productId;
                const container = modalScreen.querySelector('.js-download-modal-container');

                if (!productId || !container) {
                    callback && callback();
                    return;
                }

                // Show loader
                container.innerHTML = '<div class="c-download-modal__loader"><div class="c-download-modal__loader-spinner"></div><p>Media laden...</p></div>';

                const ajaxUrl = (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.ajax_url) ? decolegnoAjax.ajax_url : ajax_object.ajax_url;

                fetch(ajaxUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: 'get_product_download_modal_html',
                        product_id: productId,
                        security: (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) ? decolegnoAjax.nonce : ''
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        container.innerHTML = data.data.html;
                        modalContentLoaded = true;
                        initializeModalEventListeners();
                    } else {
                        container.innerHTML = '<div class="c-download-modal__error"><p>Er ging iets mis bij het laden van de media.</p></div>';
                    }
                    callback && callback();
                })
                .catch(error => {
                    console.error('Error loading modal content:', error);
                    container.innerHTML = '<div class="c-download-modal__error"><p>Er ging iets mis bij het laden van de media.</p></div>';
                    callback && callback();
                });
            }

            document.querySelectorAll('.js-modal-btn').forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    const modalScreen = document.querySelector('.js-image-modal')
                    const documentBody = document.body

                    // Handle close button inside modal
                    if (e.target.closest('.c-download-modal__close')) {
                        modalScreen.classList.remove('open')
                        documentBody.classList.remove('no-scroll')
                        return
                    }

                    if (modalScreen.classList.contains('open')) {
                        modalScreen.classList.remove('open')
                        documentBody.classList.remove('no-scroll')
                        return
                    }

                    // Open modal
                    modalScreen.classList.add('open')
                    documentBody.classList.add('no-scroll')

                    // Load content via AJAX if not already loaded
                    if (!modalContentLoaded) {
                        loadModalContent(modalScreen);
                    }
                })
            })


            document.querySelectorAll('.js-request-product-quantity').forEach(requestInputDiv => {

                const id = requestInputDiv.attributes['data-id'].value

                requestInputDiv.querySelector('select[name="quantity"]').addEventListener('change', (e) => {

                    const value = e.target.value

                    document.querySelectorAll('.js-product-on-request-modal-btn').forEach(function (btn) {

                        if (btn.attributes['data-id'] && btn.attributes['data-id'].value === id) {
                            btn.attributes['data-quantity'].value = value
                        }
                    })

                });

            });
        }
    }
)

// The endpoint also sends Content-Disposition, but set a browser-facing
// filename hint so fallback never becomes the admin-ajax URL.
function getDownloadFilenameFromUrl(url) {
    try {
        const parsedUrl = new URL(url, window.location.href);
        const queryFilename = parsedUrl.searchParams.get('download_filename');
        if (queryFilename) {
            return queryFilename;
        }

        const pathFilename = parsedUrl.pathname.split('/').filter(Boolean).pop();
        return pathFilename ? decodeURIComponent(pathFilename) : '';
    } catch (e) {
        return '';
    }
}

function getDownloadExtensionFromMime(mime) {
    const extensions = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/avif': 'avif',
        'image/svg+xml': 'svg',
        'application/pdf': 'pdf',
        'application/zip': 'zip',
        'text/plain': 'txt',
        'text/csv': 'csv',
    };

    return extensions[mime] || '';
}

function ensureDownloadFilenameExtension(filename, mime) {
    if (!filename || /\.[a-z0-9]{2,5}$/i.test(filename)) {
        return filename;
    }

    const extension = getDownloadExtensionFromMime(mime);
    return extension ? `${filename}.${extension}` : filename;
}

function setDownloadBusy(el, busy) {
    if (!el) {
        return;
    }

    el.classList.toggle('is-downloading', busy);
    el.setAttribute('aria-busy', busy ? 'true' : 'false');

    if (busy) {
        el.setAttribute('aria-label', 'Bezig met downloaden');
        return;
    }

    el.removeAttribute('aria-label');
}

function filenameFromContentDisposition(header) {
    if (!header) {
        return '';
    }

    const utfMatch = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (utfMatch) {
        return decodeURIComponent(utfMatch[1]);
    }

    const plainMatch = header.match(/filename="?([^";]+)"?/i);
    if (plainMatch) {
        return plainMatch[1];
    }

    return '';
}

function triggerBlobDownload(blob, filename) {
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    a.target = '_self';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
}

async function downloadFromOrigin(url, filename, control) {
    if (control && control.classList.contains('is-downloading')) {
        return;
    }

    setDownloadBusy(control, true);

    let downloadFilename = filename || getDownloadFilenameFromUrl(url);

    if (!downloadFilename) {
        setDownloadBusy(control, false);
        window.location.href = url;
        return;
    }

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Download request failed');
        }

        const blob = await response.blob();
        downloadFilename = ensureDownloadFilenameExtension(downloadFilename, blob.type);
        triggerBlobDownload(blob, downloadFilename);
    } catch (e) {
        window.location.href = url;
    }

    setDownloadBusy(control, false);
}

async function downloadZipFromForm(form, button) {
    if (button && button.classList.contains('is-downloading')) {
        return;
    }

    setDownloadBusy(button, true);

    const formData = new FormData(form);
    if (button && button.name) {
        formData.append(button.name, button.value);
    }

    try {
        const response = await fetch(form.getAttribute('action') || window.location.href, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });
        if (!response.ok) {
            throw new Error('Zip download failed');
        }

        const blob = await response.blob();
        const type = blob.type || '';
        if (type.indexOf('html') !== -1) {
            throw new Error('Zip download returned html');
        }

        let filename = filenameFromContentDisposition(response.headers.get('Content-Disposition'));
        if (!filename) {
            filename = 'download.zip';
        }

        triggerBlobDownload(blob, filename);
    } catch (e) {
        form.submit();
    }

    setDownloadBusy(button, false);
}

function bindDownloadModalActions() {
    if (bindDownloadModalActions.bound) {
        return;
    }

    bindDownloadModalActions.bound = true;

    document.addEventListener('click', function (e) {
        const link = e.target.closest('.c-download-modal a[download]');
        if (!link) {
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        downloadFromOrigin(link.href, link.getAttribute('download'), link);
    });

    document.addEventListener('submit', function (e) {
        const form = e.target.closest('.c-download-modal__content');
        if (!form) {
            return;
        }

        e.preventDefault();
        downloadZipFromForm(form, e.submitter);
    });
}

function initializeModalDownloadButtons() {
    bindDownloadModalActions();
}

document.addEventListener('DOMContentLoaded', function () {
    const galleryElement = document.querySelector('.c-product-gallery-popup');
    if (!galleryElement) return;

    const productGallery = lightGallery(galleryElement, {
        licenseKey: '27B98EF2-267A-4491-A872-77C77982E925',
        plugins: [lgZoom, lgVideo],
        download: true,
    });

    document.addEventListener('click', function (e) {
        const downloadBtn = e.target.closest('.lg-download');
        if (downloadBtn) {
            const downloadUrl = downloadBtn.getAttribute('href');
            if (downloadUrl && downloadUrl !== 'false') {
                e.preventDefault();
                e.stopImmediatePropagation();
                downloadFromOrigin(downloadUrl, null, downloadBtn);
            }
        }
    }, true);

    document.querySelectorAll('.splide-main__single').forEach(function (slide) {
        slide.addEventListener('click', function () {
            if (!this.getAttribute('data-splide-youtube')) {
                const slideId = this.getAttribute('data-id');
                const newSlideId = slideId - 1;
                productGallery.openGallery(newSlideId);
            }
        });
    });
})


// Initialize quantity inputs for product table (direct load, no AJAX)
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('select[name="quantity"]').forEach(quantityInput => {
        const form = quantityInput.closest('.c-product-simple-products__table__row__cart');
        if (!form) return;
        
        const submitButton = form.querySelector('button[type="submit"]');
        const emailButton = form.querySelector('.js-product-on-request-modal-btn');

        submitButton?.classList.add('disabled');

        quantityInput.addEventListener('change', () => {
            if (quantityInput.value > 0) {
                submitButton?.classList.remove('disabled');
                emailButton?.classList.remove('disabled');
            }

            if (quantityInput.value <= 0) {
                submitButton?.classList.add('disabled');
                emailButton?.classList.add('disabled');
            }
        });
    });

    // Initialize product on request modal buttons
    document.querySelectorAll('.js-product-on-request-modal-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const productInfo = {
                image: btn && btn.attributes['data-image'] ? btn.attributes['data-image'].value : '',
                label: btn && btn.attributes['data-label'] ? btn.attributes['data-label'].value : '',
                sku: btn && btn.attributes['data-sku'] ? btn.attributes['data-sku'].value : '',
                title: btn && btn.attributes['data-title'] ? btn.attributes['data-title'].value : '',
                quantity: btn && btn.attributes['data-quantity'] ? btn.attributes['data-quantity'].value : ''
            }

            toggleProductOnRequestModal(productInfo)
        })
    })

    function toggleProductOnRequestModal(productInfo) {
        const modalScreen = document.querySelector('.js-product-on-request-modal')
        const documentBody = document.body

        document.querySelector('.js-product-image').src = productInfo.image
        document.querySelector('.js-product-label').innerHTML = productInfo.label
        document.querySelector('.js-product-sku').innerHTML = '#' + productInfo.sku
        document.querySelector('.js-product-title').innerHTML = productInfo.title

        if (!productInfo.quantity || productInfo.quantity === '0') {
            document.querySelector('.js-product-quantity').innerHTML = 1
        } else {
            document.querySelector('.js-product-quantity').innerHTML = productInfo.quantity
        }

        if (document.getElementById('input_25_3') && document.getElementById('input_25_4')) {
            document.getElementById('input_25_3').value = productInfo.label + ' - #' + productInfo.sku + ' | ' + productInfo.title

            if (!productInfo.quantity || productInfo.quantity === '0') {
                document.getElementById('input_25_4').value = 1
            } else {
                document.getElementById('input_25_4').value = productInfo.quantity
            }
        }

        if (modalScreen.classList.contains('open')) {
            modalScreen.classList.remove('open')
            documentBody.classList.remove('no-scroll')

            return
        }

        if (!modalScreen.classList.contains('open')) {
            modalScreen.classList.add('open')
            documentBody.classList.add('no-scroll')
        }
    }
});